<div class="container-fluid">
  <div class="text-left row" v-show="!showCancelCodeResult">
    <div class="text-left col-6">
      <b-form-group>
        <b-form autocomplete="off">
          <b-form-input v-model="filterText" :placeholder="$t('individual.label_work_support_filter')" type="text"
            id="filter-individual-cancel-code" class="w-100 mt-4" size="sm" @input="updateFilter" />
        </b-form>
      </b-form-group>
      <cstm-table useStripeStyle useSort initSortDir="asc" rowSelect hasTabs :items="filteredCancelCodeList"
        :columns="systemTableColumns" class="support-table mt-2" type="simple" @rowClicked="clickRow" usePopup>
      </cstm-table>
    </div>
    <div class="text-left col-6">
      <b-form-group>
        <label style="font-weight: bold;" class="label-sm mt-4">{{ $t('individual.common_label_description') }}</label>
        <b-form-textarea type="text" :value="selectedCancelCode ? selectedCancelCode.menu_description : ''" class="mt-3"
          style="background-color: white;" readonly no-resize size="sm" rows="12">
        </b-form-textarea>
        <div class="text-right w-100">
          <b-button @click="onClickSelect()" size="sm" class="mt-2" variant="primary">
            {{ $t('individual.button_work_support_select') }}
          </b-button>
        </div>
      </b-form-group>
    </div>
  </div>

  <cancel-code-result v-if="showCancelCodeResult"
    @close-result="closeResult"
    :i18nCncKey="i18nCncKey"
    :cancelCodeId="cancelCodeId"
    :functionList="functionList" />
  <processing-view :processing="processing"></processing-view>
</div>